export type TrayWidthOpts = {
  visibleSlides?: number;
  offset?: number;
  slideMarginPx: number;
};

export function computeAndSetTrayWidth(
  variable: string,
  carouselEl: HTMLElement,
  slidesCount: number,
  opts: TrayWidthOpts
): void {
  const visible = opts.visibleSlides || 1;
  const realSlidesNumber = slidesCount / visible;
  const gapPx = realSlidesNumber * opts.slideMarginPx;
  const baseWidth = carouselEl.style.width;

  carouselEl.style.setProperty(variable, `calc(${baseWidth} - ${(opts.offset ?? 0) * realSlidesNumber}% + ${gapPx}px)`);
}
